export default __webpack_public_path__ + "static/media/login.d6fe67ae.jpg";